import { Panel } from "primereact/panel"
import { ConyCpn } from "../../../models/cpn/ConyCpn";
import { CatalogoService } from "../../../service/CatalogoService";
import { useForm } from "react-hook-form";
import { InputComponent } from "../../../components/InputComponent";
import * as generic from "../../../components/Generico";
import { ClientePNService } from "../../../service/ClientePNService";
import { useEffect, useState } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { BottomActionBar } from "../../../components/ui/BottomActionBar";
import { InputActividadEconomica } from "../../../components/ui/Formularios/InputActividadEconomica";

export const ConyuguePn = ({ id, catalogos, toast, seccion, back, next, permss, soloLectura }) => {

    const omodel = new ConyCpn();
    const defaultValues = generic.funDefault(omodel.model);
    const catalogoSrv = new CatalogoService();
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue, clearErrors } = useForm({ defaultValues, mode: 'onTouched' });
    const { inDrop, inText, inNumber, inCalendar } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const clientepnSrv = new ClientePNService();
    const [ecuadorTR, setEcuadorTR] = useState(false);
    const [ciudadesTR, setCiudadesTR] = useState([]);
    const [otraSituacion, setOtraSituacion] = useState(false);
    const [esCedula, setEsCedula] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [siOtraFuente, setSiOtraFuente] = useState(false);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const onChangePaisTR = (e) => {
        setEcuadorTR(e.value?.cat_id === catalogos.ecuador?.cat_id);
        setValue('provincia_tr_cy', null);
        setValue('ciudad_tr_cy', null);
        setCiudadesTR([]);
    }

    const onChangeSituacion = (e) => {
        setOtraSituacion(e.value?.cat_id === catalogos.otra?.cat_id);
    }

    const onChangeTipoIdentificacion = (e) => {
        setEsCedula(e.value?.cat_id === catalogos?.cedula?.cat_id);
        clearErrors('identificacion_cy');
    }

    const onChangeProvinciaTR = (e) => {
        setValue('ciudad_tr_cy', null);
        if (!e?.value) {
            setCiudadesTR([]);
            return;
        }
        catalogoSrv.getCatalogosId(e.value.cat_id).then(res => {
            setCiudadesTR(res.data);
        });
    }

    const onSubmit = (data) => {
        setIsSaving(true);
        data.seccion = seccion;
        data.ec = catalogos.ecuador.cat_id;
        data.id = id;
        data.fecha_nacimiento_cy = data.fecha_nacimiento_cy.toISOString().split('T')[0];
        clientepnSrv.editarClientepn(data).then(res => {
            generic.funcSuccess(res, toast);
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const editFicha = () => {
        setIsLoading(true);
        clientepnSrv.consultarClientepn(id, seccion).then(res => {
            const cats = catalogos;
            const _clientepn = res.data.clientepn;
            if (res.data.ciudad_tr_cy) {
                setCiudadesTR(res.data.ciudad_tr_cy);
            }
            setSiOtraFuente(_clientepn?.otro_ingreso_mes_cy > 0);
            setEcuadorTR(_clientepn.pais_tr?.cat_id === cats.ecuador?.cat_id);
            setOtraSituacion(_clientepn.situacion_laboral_cy?.cat_id === cats.otra?.cat_id);
            setEsCedula(_clientepn.tipo_identificacion_cy?.cat_id === cats?.cedula?.cat_id);
            _clientepn.fecha_nacimiento_cy = generic.stringToDate(_clientepn.fecha_nacimiento_cy);
            reset(generic.renewValues(_clientepn, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Por favor complete los campos requeridos.', life: 5000 });
    }

    const onChangeOtraFuente = (e) => {
        setSiOtraFuente(e.value > 0);
        if (!e.value || e.value === 0) {
            setValue('detalle_otro_ingreso_cy', '');
        }
    }

    const tipoDoc = esCedula ? 'IDEN_CEDULA' : null;

    const reglaValidacion = (val) => {
        if (!tipoDoc) return true;
        return generic.validarIdentificacionEcuador(val, tipoDoc) || `Cédula incorrecta`;
    };

    return (
        <div className="fadein animation-duration-300">
            <form id="conyugePnForm" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
                <Panel header={generic.renderPanelHeader('A.4', 'DATOS DEL CÓNYUGE/CONVIVIENTE', 'pi pi-heart')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid">
                        <div className="col-12 mb-3 mt-1">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-user text-primary"></i>
                                    DATOS DE IDENTIFICACIÓN Y PERSONALES
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>
                        {inText('apellidos_cy', { icon: 'pi pi-user-edit' }, 3)}
                        {inText('nombres_ec', { icon: 'pi pi-user' }, 3)}
                        {inDrop('tipo_identificacion_cy', catalogos?.tipo, { lab: omodel.optionLabel, chn: onChangeTipoIdentificacion }, 3)}
                        {inText('identificacion_cy', { validate: reglaValidacion, icon: 'pi pi-id-card' }, 3)}

                        {inDrop('nacionalidad_cy', catalogos?.nacionalidad, { lab: omodel.optionLabel }, 3)}
                        {inCalendar('fecha_nacimiento_cy', {}, 3)}
                        {inDrop('genero_cy', catalogos?.genero, { lab: omodel.optionLabel }, 3)}
                        {inDrop('situacion_laboral_cy', catalogos?.situacionLaboralCy, { lab: omodel.optionLabel, chn: onChangeSituacion }, 3)}
                        <div className="col-12 mb-3 mt-4">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-briefcase text-primary"></i>
                                    INFORMACIÓN LABORAL Y ACTIVIDAD
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        {otraSituacion && inText('detalle_sl_cy', { icon: 'pi pi-comment' }, 3)}
                        {inText('lugar_trabajo_cy', { icon: 'pi pi-building' }, otraSituacion ? 3 : 4)}
                        {inText('cargo_cy', { icon: 'pi pi-briefcase' }, otraSituacion ? 3 : 4)}
                        {inText('ruc_cy', { obl: 'no', icon: 'pi pi-id-card' }, otraSituacion ? 3 : 4)}

                        {inText('tiempo_trabajo_cy', { icon: 'pi pi-clock' }, 12)}
                        <InputActividadEconomica name="actividad_economica_cy" control={control} modelDef={omodel.model['actividad_economica_cy']} disabled={soloLectura} col={12} />
                        {inText('direccion_trabajo_cy', { icon: 'pi pi-map-marker' }, 12)}

                        {inDrop('pais_tr', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePaisTR, val: false }, ecuadorTR ? 4 : 6)}
                        {ecuadorTR ? (
                            <>
                                {inDrop('provincia_tr_cy', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvinciaTR, val: false }, 4)}
                                {inDrop('ciudad_tr_cy', ciudadesTR, { lab: omodel.optionLabel }, 4)}
                            </>
                        ) : (
                            inText('canton_tr_cy', { icon: 'pi pi-map-marker' }, 6)
                        )}

                        {inText('telefono_trabajo_cy', { icon: 'pi pi-phone' }, 6)}
                        {inText('email_trabajo_cy', { icon: 'pi pi-envelope' }, 6)}
                        <div className="col-12 mb-3 mt-4">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-dollar text-primary"></i>
                                    INFORMACIÓN FINANCIERA MENSUAL
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        {inNumber('ingreso_mensual_cy', 2, true, { icon: 'pi pi-arrow-up-right', iconPosition: 'left' }, siOtraFuente ? 3 : 4)}
                        {inNumber('egreso_mensual_cy', 2, true, { icon: 'pi pi-arrow-down-right', iconPosition: 'left' }, siOtraFuente ? 3 : 4)}
                        {inNumber('otro_ingreso_mes_cy', 2, true, { icon: 'pi pi-wallet', iconPosition: 'left', func: onChangeOtraFuente }, siOtraFuente ? 3 : 4)}
                        {siOtraFuente && inText('detalle_otro_ingreso_cy', { obl: 'no', icon: 'pi pi-comment' }, 3)}

                    </div>
                </Panel>

                <BottomActionBar formId="conyugePnForm" onPrev={back} onNext={next} loading={isSaving} isReadOnly={soloLectura} />
            </form>
        </div>
    );
}
